import React, { useEffect, useState } from "react";
import { useForm } from '@formspree/react';

import Input from "./Form/Input";
import Submit from "./Form/Submit";
import Success from "./Form/Success";

function ContactForm({formId, locale}) {

    const [state, handleSubmit] = useForm(formId);
    const [messages, setMessages] = useState([]);

    const i18n = (key, locale) => {
        const data = messages.filter((data) => data.key == key).shift();

        return data && data.translations[locale]
            ? data.translations[locale].message
            : null
       ;
    }

    useEffect(() => {
        if(messages.length > 0) {
            return;
        }

        fetch(`/_data/messages.json`)
            .then((response) => response.json())
            .then((data) => setMessages(data))
        ;
    });

    if (state.succeeded) {
        return (
            <Success
                message="Merci ! Votre demande a bien été envoyée."
            />
        );
    }

    return (
        <form
            className="grid grid-cols-1 gap-4 mx-auto max-w-screen-sm"
            onSubmit={handleSubmit}
        >
            <Input
                state={state}
                field="_firstname"
                options={{
                    required: true,
                    placeholder: i18n('form.contact.firstname', locale)
                }}
            />
            <Input
                state={state}
                field="_name"
                options={{
                    required: true,
                    placeholder: i18n('form.contact.lastname', locale)
                }}
            />
            <Input
                state={state}
                field="_replyto"
                options={{
                    required: true,
                    placeholder: i18n('form.contact.email', locale),
                    type: "email"
                }}
            />
            <Input
                state={state}
                field="_phone"
                options={{
                    placeholder: i18n('form.contact.phone', locale)
                }}
            />
            <Input
                state={state}
                field="_subject"
                options={{
                    required: true,
                    placeholder: i18n('form.contact.subject', locale)
                }}
            />
            <Input
                state={state}
                field="_message"
                textarea={true}
                options={{
                    required: true,
                    placeholder: i18n('form.contact.message', locale),
                    rows: 5
                }}
            />
            <Submit
                state={state}
                label={ i18n('form.contact.submit', locale) }
            />
        </form>
    )
}

export default ContactForm;
